const hoursOfDay = [
  "00:00",
  "00:30",
  "01:00",
  "01:30",
  "02:00",
  "02:30",
  "03:00",
  "03:30",
  "04:00",
  "04:30",
  "05:00",
  "05:30",
  "06:00",
  "06:30",
  "07:00",
  "07:30",
  "08:00",
  "08:30",
  "09:00",
  "09:30",
  "10:00",
  "10:30",
  "11:00",
  "11:30",
  "12:00",
  "12:30",
  "13:00",
  "13:30",
  "14:00",
  "14:30",
  "15:00",
  "15:30",
  "16:00",
  "16:30",
  "17:00",
  "17:30",
  "18:00",
  "18:30",
  "19:00",
  "19:30",
  "20:00",
  "20:30",
  "21:00",
  "21:30",
  "22:00",
  "22:30",
  "23:00",
  "23:30",
];
const stateList = [
  "Nuevo León",
  "Aguascalientes",
  "Baja California",
  "Baja California Sur",
  "Campeche",
  "Chiapas",
  "Chihuahua",
  "Ciudad de México",
  "Coahuila",
  "Colima",
  "Durango",
  "Estado de México",
  "Guanajuato",
  "Guerrero",
  "Hidalgo",
  "Jalisco",
  "Michoacán",
  "Morelos",
  "Nayarit",
  "Oaxaca",
  "Puebla",
  "Querétaro",
  "Quintana Roo",
  "San Luis Potosí",
  "Sinaloa",
  "Sonora",
  "Tabasco",
  "Tamaulipas",
  "Tlaxcala",
  "Veracruz",
  "Yucatán",
  "Zacatecas",
  "Internacional",
];
const bankList = [
  "ACCIVAL",
  "ACTINVER",
  "AFIRME",
  "ALBO",
  "AMERICAN EXPRES",
  "ARCUS FI",
  "ASP INTEGRADORA OPC",
  "AXA",
  "AZTECA",
  "BAJIO",
  "BAMSA",
  "BANAMEX",
  "BANCO COVALTO",
  "BANCO FAMSA",
  "BANCO FINTERRA",
  "BANCO S3",
  "BANCO SHINHAN DE MEXICO",
  "BANCOMEXT",
  "BANCOPPEL",
  "BANCREA",
  "BANJERCITO",
  "BANK OF CHINA",
  "BANKAOOL",
  "BANOBRAS",
  "BANORTE/IXE",
  "BANREGIO",
  "BANSEFI",
  "BANSI",
  "BANXICO",
  "BARCLAYS",
  "BBVA BANCOMER",
  "BMONEX",
  "CAJA POP MEXICA",
  "CAJA TELEFONIST",
  "CARTERA DIGITAL",
  "CASHI CUENTA",
  "CB ACTINVER",
  "CB INTERCAM",
  "CB JPMORGAN",
  "CBDEUTSCHE",
  "CI BOLSA",
  "CITI MEXICO",
  "CLS",
  "COMPARTAMOS",
  "CONSUBANCO",
  "CREDICAPITAL",
  "CREDICLUB",
  "CREDIT SUISSE",
  "CRISTOBAL COLON",
  "CUENCA TECNOLOGIA FINANCIERA",
  "DONDE",
  "EVERCORE",
  "FINAMEX",
  "FINCO PAY",
  "FINCOMUN",
  "FND",
  "FOMPED",
  "FONDEADORA",
  "FONDO (FIRA)",
  "GBM",
  "HDI SEGUROS",
  "HEY BANCO",
  "HIPOTECARIA FED",
  "HSBC",
  "HSBC2",
  "HUASTECAS",
  "ICBC",
  "INBURSA",
  "INDEVAL",
  "INFONAVIT",
  "INMOBILIARIO",
  "INTERACCIONES",
  "INTERCAM BANCO",
  "INTERCAM BANCO",
  "INVERCAP",
  "INVEX",
  "JP MORGAN",
  "KAPITAL",
  "KLAR ALTERNATIVOS",
  "KUSPIT",
  "LIBERTAD",
  "MASARI",
  "MERCADO PAGO W",
  "MEXPAGO",
  "MIFEL",
  "MIZUHO BANK",
  "MONEXCB",
  "MUFG",
  "MULTIVA BANCO",
  "MULTIVA CBOLSA",
  "NAFIN",
  "NU MEXICO",
  "NVIO",
  "ORDER",
  "OSKNDIA",
  "PAGATODO",
  "PEIBO",
  "PROFUTURO",
  "REFORMA",
  "SABADELL",
  "SANTANDER",
  "SANTANDER2",
  "SCOTIABANK",
  "SKANDIA",
  "SOFIEXPRESS",
  "SPID",
  "SPIN BY OXXO",
  "STP",
  "SURA",
  "TESORED",
  "TRANSFER",
  "UALA",
  "UNAGRA",
  "VALMEX",
  "VALUE",
  "VE POR MAS",
  "VECTOR",
  "VOLKSWAGEN",
  "ZURICH",
  "ZURICHVI",
];

export { stateList, hoursOfDay, bankList };
